import React from "react";
import { PRODUCT_STATUS } from "../utils";

/**
 * Action Buttons Component
 * Submit, Accept/Reject, Edit buttons based on status
 */
const ActionButtons = ({
  status,
  isEditing,
  onSubmit,
  onStatusChange,
  onEdit,
}) => {
  if (
    status === PRODUCT_STATUS.OPEN ||
    isEditing ||
    status === PRODUCT_STATUS.DRAFT
  ) {
    return (
      <div className="flex justify-center mt-8">
        <button
          type="button"
          onClick={onSubmit}
          className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-all shadow-md"
        >
          Submit Product
        </button>
      </div>
    );
  }

  if (status === PRODUCT_STATUS.PENDING) {
    return (
      <div className="flex justify-center gap-4 mt-8">
        <button
          type="button"
          onClick={() => onStatusChange("accept")}
          className="px-8 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:ring-4 focus:ring-green-300 transition-all shadow-md"
        >
          Accept
        </button>
        <button
          type="button"
          onClick={() => onStatusChange("reject")}
          className="px-8 py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 focus:ring-4 focus:ring-red-300 transition-all shadow-md"
        >
          Reject
        </button>
      </div>
    );
  }

  if (
    (status === PRODUCT_STATUS.APPROVED ||
      status === PRODUCT_STATUS.REJECTED) &&
    !isEditing
  ) {
    return (
      <div className="flex justify-center mt-8">
        <button
          type="button"
          onClick={onEdit}
          className="px-8 py-3 bg-yellow-600 text-white font-semibold rounded-lg hover:bg-yellow-700 focus:ring-4 focus:ring-yellow-300 transition-all shadow-md"
        >
          Edit Product
        </button>
      </div>
    );
  }

  return null;
};

export default ActionButtons;
